import { render, staticRenderFns } from "./roomstable.vue?vue&type=template&id=23668878&scoped=true"
import script from "./roomstable.vue?vue&type=script&lang=js"
export * from "./roomstable.vue?vue&type=script&lang=js"
import style0 from "./roomstable.vue?vue&type=style&index=0&id=23668878&prod&scoped=true&lang=scss"
import style1 from "./roomstable.vue?vue&type=style&index=1&id=23668878&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23668878",
  null
  
)

export default component.exports